<template>
  <b-card
    class="earnings-card"
  >

    <b-row>

      <b-col cols="4" class ="col-lg-4 col-sm-6" v-for="(planCount,index) in data">
        <b-card-title class="mb-0">
          {{planCount.name}}
        </b-card-title>
        <b-card-text class="text-muted font-small-2">
          <span class="font-weight-bolder">{{planCount.percentage}}%</span><span> of subscribed user this Month.</span>
        </b-card-text>
        <div class="font-small-2">
          This Month
        </div>
        <h5 class="mb-0">
          {{planCount.total}}
        </h5>

      </b-col>
      <!-- <b-col cols="3">
        <vue-apex-charts
          height="120"
          :options="earningsChart.chartOptions"
          :series="series"
        />
      </b-col> -->
    </b-row>
  </b-card>
</template>

<script>
import {
    BCard, BRow, BCol, BCardTitle, BCardText,
} from 'bootstrap-vue-3'
import VueApexCharts from 'vue3-apexcharts'
// import axios from 'axios'
const $earningsStrokeColor2 = '#28c76f66'
const $earningsStrokeColor3 = '#28c76f33'
const $themeColors = 'rgb(40, 199, 111)'
export default {
  name:'MonthlySignupStats',
  components: {
    BCard,
    BRow,
    BCol,
    BCardTitle,
    BCardText,
    VueApexCharts,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      data:{},
      maxPercentage:'50%',
      label:'',
      series: [0,0,0],
      earningsChart: {
        chartOptions: {
          chart: {
            type: 'donut',
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          comparedResult: [2, -3, 8],
          labels: [ 'Self User', 'Family User','Business User'],
          stroke: { width: 0 },
          colors: [$earningsStrokeColor2, $earningsStrokeColor3, $themeColors],
          grid: {
            padding: {
              right: -20,
              bottom: -8,
              left: -20,
            },
          },
          plotOptions: {
            pie: {
              startAngle: -10,
              donut: {
                labels: {
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter(val) {
                      return `${parseInt(val)}%`
                    },
                  },
                  total: {
                    show: true,
                    offsetY: 15,
                    label:'',
                    formatter() {
                      return this.maxPercentage
                    },
                  },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 1325,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
            {
              breakpoint: 1045,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
          ],
        },
      },
    }
  },
  created(){
    this.getStatistics();
  },
    methods: {
        getStatistics() {
            let donutData = this.earningsChart.chartOptions.plotOptions.pie.donut.labels.total;
            let newLabel = donutData.label
            let status = {
                status: 0
            }
            const route = this.$router.resolve(
                {
                    name: 'admin-monthly-signup-stats',
                }
            );
            axios.post(route.href,status).then(({data})=>{
                let datas = data.data;
                this.data =datas;
                let arpercentage = [];
                let planCount = [];
                let donutdata =[];
                datas.forEach((item, i) => {
                    arpercentage.push(item.percentage);
                    planCount.push(item);
                });
                var maxPercentage = arpercentage.sort((a,b)=> a-b)[arpercentage.length-1];
                datas.forEach((item, i) => {
                    if(item.percentage ==maxPercentage){
                        donutdata.push(item)
                    }
                });
                let doNut = donutdata[0];
                this.earningsChart.chartOptions.plotOptions.pie.donut.labels.total = {
                    show: true,
                    offsetY: 15,
                    label:donutdata[0].name,
                    formatter() {
                        return donutdata[0].percentage+"%"
                    },
                }
                // donutData.formatter=this.formatter(doNut.percentage)
                this.series = arpercentage;
            }).catch();
        }
    },
}
</script>
